import { useEffect, useState } from "react"

// Submits the screen's resend form ("Resend the link" on the reset flow,
// "Resend code" on email verification). The server lands the visitor back on
// the same screen after a resend with `cooldown` seconds (design: 30) during
// which the button is disabled and counts down, so a resend cannot be fired
// again and again.
export default function ResendButton({ cooldown = 0, label = "Resend the link" }) {
  const [left, setLeft] = useState(cooldown)
  const counting = left > 0

  useEffect(() => {
    if (!counting) return undefined
    const id = setInterval(() => setLeft((value) => value - 1), 1000)
    return () => clearInterval(id)
  }, [counting])

  return (
    <button
      type="submit"
      disabled={left > 0}
      className="font-bold text-foreground underline decoration-line-2 underline-offset-[3px] hover:decoration-foreground disabled:text-ink-3 disabled:no-underline"
    >
      {left > 0 ? `Resend in ${left}s` : label}
    </button>
  )
}
